import { Component, OnInit } from '@angular/core';
import { ScriptLoaderService } from '../../../_services';


@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--hor-desktop.m-grid--desktop.m-body",
    templateUrl: "./aside-left-display-disabled.component.html",
    styles: [`
    	.m-page__container {
    		margin-top: 160px;
    	}
    `]
})
export class AsideLeftDisplayDisabledComponent implements OnInit {


    constructor() {

    }
    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/aside-left-display-disabled.component.ts